















































import Vue, { PropType } from 'vue'
import Icon from '@/ui/icon/Icon.vue'
import BaseButton from '@/ui/button/BaseButton.vue'
import Loader from '@/pages/common/parts/loader/Loader.vue'
import { navigatePush } from '@/features/navigation/navigationMethods'
import { getStudentTokenFx } from '@/features/api/employee/getStudentToken'
import { getStudentToken } from '@/pages/users/students/edit/model/edit-student.model'

export default Vue.extend({
  name: 'EditStudentHeader',
  components: {
    Icon,
    BaseButton,
    Loader,
  },
  props: {
    title: { type: String as PropType<string>, default: '' },
    disabled: { type: Boolean as PropType<boolean>, default: true },
    isPreview: { type: Boolean as PropType<boolean> },
    fromPage: { type: String as PropType<string> },
    taskType: { type: String as PropType<string> },
    statusController: { type: Boolean as PropType<boolean>, default: false },
  },
  effector: {
    isLoading: getStudentTokenFx.pending,
  },
  methods: {
    goToList() {
      switch (this.$route.name) {
        default:
          navigatePush({ name: 'users-list' })
      }
    },
    onSaveClick() {
      this.$emit('save')
    },
    onSaveAndBackClick() {
      this.$emit('saveAndBackToList')
    },
    goToInterface() {
      getStudentToken()
    },
  },
})
